// Production URL
const production = {
    // url: "http://10.20.80.87/Cashpickupportal/api",
    url: "https://suyool.money/CashpickUP/api/v1",
    // url: "https://api.suyool.com/CashDeliveryPortal",
    // urlback: "http://10.20.80.62:3008/api"
    // urlWebSocket: "https://suyool.money/CashpickUP"
}

// Development URL
const development = {
    // url: "http://10.20.80.87/Cashpickupportal/api",
    // url: "https://api.suyool.com/CashDeliveryPortal",
    url: "https://suyool.money/CashpickUP/api/v1",
    // urlback: "http://10.20.80.62:3008/api"
    // urlWebSocket: "https://suyool.money/CashpickUP"
}

export const isDevMode = process.env.NODE_ENV !== "production";

export const checkQrStatusTimer = 3000
export const qrTimeoutMinutes = isDevMode ? 10 : 1;
export const config = isDevMode ? development : production;

export const inactivityDuration = isDevMode ? 1000 * 60 * 1000 : 10 * 60 * 1000; 
export const entityRoles = {
    arz: "ARZ",
    superAdmin: "SUPERADMIN",
    employee: "EMPLOYEE"
}

export const entityTypes = {
    legal: "LEGALENTITY",
    merchant: "MERCHANTEMPLOYEE",
  };

  
export const validationTypes = {
    cardInfo: 1,
    employee: 2,
    s2s: 3,
    cashing: 4
}

export const employeeActions = {
    Delete: 1,
    GenerateOTP: 2,
    ResetOTP: 3,
    BlockUnBlock: 4,
  }